<template>
  <div class="error">
    <span class="material-icons">domain_disabled</span>
    {{ error }}
  </div>
</template>

<script>
import { getRedirectPath } from '@/router'

export default {
  name: 'Home',
  inject: ['companyUser'],
  data: () => ({
    error: null,
  }),
  async beforeMount() {
    // either redirect or set error

    if (!this.companyUser) {
      this.error = this.$t('home.emptyAccount')
      return
    }

    const redirectPath = getRedirectPath(this.companyUser, this.$route.fullPath)

    if (redirectPath) {
      this.$router.push(redirectPath)
      return
    }

    // Handle useres without access to binity app
    ;['route_driver', 'order_creator', 'order_driver'].forEach(role => {
      if (this.companyUser.roles.includes(role)) this.error = this.$t('home.noAccess', role)
    })
  },
}
</script>

<style lang="scss" scoped>
.error {
  white-space: pre-line;
  text-align: center;
  position: relative;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 3rem;
  letter-spacing: 1px;
  margin-top: 10%;

  span {
    position: absolute;
    opacity: 0.1;
    font-size: 15rem;
    bottom: 50%;
    transform: translate(-65%, 50%);
  }
}
</style>
